import { IconStyled, IconStylesProps } from './IconStyles';

export const Running = ({ size = 'base', className = '', fill = 'currentColor' }: Partial<IconStylesProps>) => (
  <IconStyled
    size={size}
    className={className}
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="6.08344" cy="6" rx="6.08344" ry="6" fill={fill} />
    </IconStyled>
);
